export default [
    { path: '/', component: require('./components/site/Homepage.vue').default },
    { path: '/browse/:criteria?', component: require('./components/site/Browse.vue').default },
    { path: '/openHouses', component: require('./components/site/Browse.vue').default, props: { listing_type: "openHouses" } },
    { path: '/favorites', component: require('./components/site/Browse.vue').default, props: { listing_type: "favorites" } },
    { path: '/about', component: require('./components/site/About.vue').default },
    { path: '/:slug', component: require('./components/AgentProfile.vue').default },
    { path: '/:slug?/testimonials', component: require('./components/AgentTestimonials.vue').default },
    { path: '/listing/:listingId', component: require('./components/site/Listing.vue').default },
    { path: '*', component: require('./components/NotFound.vue').default },
];
